import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import { TabletStoredGoodsReceiptsContainer } from "@/screens/Tablet/WarehouseReceiving/Stored"
import { goodsReceiptPalletsSearchSchema } from "@/screens/WarehouseReceiving/schemas"

export const Route = createFileRoute("/app/tablet/warehouse-receiving/_layout/stored")({
  validateSearch: zodValidator(goodsReceiptPalletsSearchSchema),
  component: TabletStoredGoodsReceiptsContainer,
})
